import { render, staticRenderFns } from "./ReportBlock.vue?vue&type=template&id=f47753c8&scoped=true"
import script from "./ReportBlock.vue?vue&type=script&lang=js"
export * from "./ReportBlock.vue?vue&type=script&lang=js"
import style0 from "./ReportBlock.vue?vue&type=style&index=0&id=f47753c8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47753c8",
  null
  
)

export default component.exports